var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('Header',{ref:"layoutHeader"}),_c('router-view',{on:{"initCart":_vm.initCart}}),_c('Sidebar',{ref:"layoutSidebar"}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }